"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = preloadImage;

var _Url = _interopRequireDefault(require("urlinator/Url"));

var _file = require("FileManagerCore/utils/file");

var cache = {};

var noop = function noop() {
  return undefined;
};

function preloadImage(src) {
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
  var err = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : noop;

  if (cache[src]) {
    callback(cache[src]);
    return noop;
  }

  var img = new window.Image();
  var cancelled = false;

  var loadHandler = function loadHandler() {
    if (cancelled) {
      return;
    }

    var parsed = new _Url.default(src);
    var segments = parsed.pathname.split('/');

    var _splitNameAndExtensio = (0, _file.splitNameAndExtension)({
      name: segments[segments.length - 1]
    }),
        name = _splitNameAndExtensio.name,
        extension = _splitNameAndExtensio.extension;

    var meta = {
      width: img.width,
      height: img.height,
      name: name,
      extension: extension
    };
    cache[src] = meta;
    callback(meta);
  };

  var errorHandler = function errorHandler(error) {
    if (cancelled) {
      return;
    }

    cache[src] = false;
    err(error);
  };

  img.src = src;
  img.addEventListener('load', loadHandler);
  img.addEventListener('error', errorHandler);
  return function () {
    if (cancelled) {
      return;
    }

    cancelled = true;
    img.removeEventListener('load', loadHandler);
    img.removeEventListener('error', errorHandler);
  };
}

module.exports = exports.default;